export default __webpack_public_path__ + "img/mobile-arrow-left.579ee418.svg";